import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2e252eaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo-word" }
const _hoisted_2 = { class: "logo-sub" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "logo",
    style: _normalizeStyle({ '--px': _ctx.pixelSize + 'px' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logoLetters, (letter, li) => {
        return (_openBlock(), _createElementBlock("div", {
          key: li,
          class: _normalizeClass(["letter", { narrow: letter.length === 24 }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(letter, (pixel, pi) => {
            return (_openBlock(), _createElementBlock("span", {
              key: pi,
              class: _normalizeClass(["pixel", { on: pixel === 1 }]),
              style: _normalizeStyle(pixel === 1 ? { animationDelay: (li * 0.09 + pi * 0.006) + 's' } : undefined)
            }, null, 6))
          }), 128))
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList('CONSULTING', (char, i) => {
        return _createElementVNode("span", {
          key: i,
          style: _normalizeStyle({ animationDelay: 0.6 + i * 0.04 + 's' })
        }, _toDisplayString(char), 5)
      }), 64))
    ])
  ], 4))
}